import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      gap: theme.spacing(2),
    },
    sectionTitle: {
      color: COLORS.gray.gray30,
      fontWeight: theme.typography.fontWeightMedium,
    },
    formatsList: {
      display: 'flex',
      flexFlow: 'column nowrap',
    },
    compliantBox: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1.5),
      background: COLORS.neutral.white,
      border: theme.shape.borderGray70,
      borderRadius: theme.shape.borderRadiusSemiLarge,
      padding: theme.spacing(2),
      marginBottom: theme.spacing(1),
      boxShadow: 'none',
    },
    checkmarkIcon: {
      fontSize: theme.typography.pxToRem(20),
      color: COLORS.success.green,
    },
    formatText: {
      color: COLORS.neutral.secondary,
    },
  }),
  { name: 'FormatCompliantFormats' }
);
